export default "/images/play.svg?7c595cc952560306ed094adbc08d5de9";